import {Form, Formik} from 'formik';
import {Button, Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {IconButtonSave} from 'src/app/modules/component/IconSvg';
import * as Yup from 'yup';
import AutocompleteV2 from "../../../../../../../component/AutocompleteObjectV2";
import {getObsComplexCategory} from "../../../../../../../utils/ServicesUtils";
import React from "react";
import {API_PATH} from "../service";

type Props = {
  open: boolean;
  handleClose: () => void;
  onSave?: (data?: any) => void;
};

const ModalLoaiBenhAn = ({open, handleClose, onSave}: Props) => {
  const intl = useIntl();

  const validationSchema = Yup.object({
    medicalRecordType: Yup.mixed().required(intl.formatMessage({id: 'VALIDATION.REQUIRE'})),
  });

  const onSubmit = (values: any) => {
    onSave && onSave(values);
  };

  return (
    <Modal show={open} animation centered className="dialog-background">
      <Formik
        initialValues={{
          medicalRecordType: "",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({values, setFieldValue, errors, touched}) => (
          <Form>
            <Modal.Header className="py-3 header-modal">
              <Modal.Title className="text-pri">Loại bệnh án</Modal.Title>
              <Button className="btn-close bg-white" onClick={handleClose}></Button>
            </Modal.Header>
            <Modal.Body className="py-16 px-24 spaces">
              <AutocompleteV2
                options={[]}
                searchFunction={getObsComplexCategory}
                searchObject={{
                  path: API_PATH,
                  code: 'loaibenhan',
                  pageIndex: 1,
                  pageSize: 9999,
                }}
                urlData="data.content"
                value={values?.medicalRecordType}
                name="medicalRecordType"
                onChange={(selectedOption) =>
                  setFieldValue(
                    'medicalRecordType',
                    selectedOption
                  )
                }
                errors={errors?.medicalRecordType}
                touched={touched?.medicalRecordType}
              />
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-end">
              <Button className="btn-outline" onClick={handleClose}>
                Đóng
              </Button>
              <Button className="btn-fill" type="submit">
                <IconButtonSave/>
                Lưu
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalLoaiBenhAn;
